import React, { useState } from 'react';
import '../../components/AstroAgentsPage.css';

const AstroAgentsPage = () => {
  // Dados fictícios para os agentes de IA
  const [agents] = useState([
    { id: 1, name: 'Nebula', description: 'Assistente de análise de dados e relatórios', status: 'online' },
    { id: 2, name: 'Orion', description: 'Especialista em suporte técnico e resolução de problemas', status: 'online' },
    { id: 3, name: 'Vega', description: 'Consultor de vendas e relacionamento com clientes', status: 'offline' },
    { id: 4, name: 'Sirius', description: 'Analista de tendências de mercado e comportamento do cliente', status: 'online' },
    { id: 5, name: 'Polaris', description: 'Gerente de projetos e coordenação de equipes', status: 'busy' },
  ]);

  // Dados fictícios para as últimas conversas
  const [conversations] = useState([
    { id: 101, agentName: 'Nebula', title: 'Relatório de atendimento mensal', timestamp: '2025-07-29 14:30', preview: 'Este mês tivemos um aumento de 15% nas interações...'},
    { id: 102, agentName: 'Orion', title: 'Solução para problema de login', timestamp: '2025-07-29 11:15', preview: 'O problema foi resolvido atualizando o módulo de autenticação...'},
    { id: 103, agentName: 'Sirius', title: 'Análise de satisfação do cliente', timestamp: '2025-07-28 16:45', preview: 'A satisfação geral aumentou para 92% este trimestre...'},
    { id: 104, agentName: 'Nebula', title: 'Processamento de solicitações', timestamp: '2025-07-28 09:20', preview: 'Automatizei 80% das solicitações repetitivas...'},
    { id: 105, agentName: 'Polaris', title: 'Status do projeto de integração', timestamp: '2025-07-27 13:10', preview: 'O projeto de integração com o CRM está 75% concluído...'},
  ]);

  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([
    { id: 1, sender: 'agent', content: 'Olá! Sou Nebula, sua assistente de análise de dados. Como posso ajudar você hoje?', timestamp: '2025-07-29 14:30' }
  ]);
  const [newMessage, setNewMessage] = useState('');

  const handleAgentSelect = (agent) => {
    setSelectedAgent(agent);
    setSelectedConversation(null);
    // Iniciar nova conversa com o agente
    setMessages([
      { id: 1, sender: 'agent', content: `Olá! Sou ${agent.name}, ${agent.description}. Como posso auxiliar você no atendimento hoje?`, timestamp: new Date().toLocaleString() }
    ]);
  };

  const handleConversationSelect = (conversation) => {
    setSelectedConversation(conversation);
    setSelectedAgent(null);
    // Carregar mensagens da conversa
    setMessages([
      { id: 1, sender: 'agent', content: `Olá! Esta é a conversa com ${conversation.agentName} sobre "${conversation.title}"`, timestamp: conversation.timestamp },
      { id: 2, sender: 'user', content: conversation.preview, timestamp: conversation.timestamp }
    ]);
  };

  const handleSendMessage = () => {
    if (newMessage.trim() === '') return;
    
    const newMsg = {
      id: messages.length + 1,
      sender: 'user',
      content: newMessage,
      timestamp: new Date().toLocaleString()
    };
    
    setMessages([...messages, newMsg]);
    setNewMessage('');
    
    // Simular resposta do agente
    setTimeout(() => {
      const agentResponse = {
        id: messages.length + 2,
        sender: 'agent',
        content: `Entendi sua solicitação. Estou analisando as informações e já retorno com uma resposta completa.`,
        timestamp: new Date().toLocaleString()
      };
      setMessages(prev => [...prev, agentResponse]);
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="astro-agents-page">
      <div className="astro-agents-header">
        <h2>Astro Agentes</h2>
        <p>Converse com nossos agentes de IA especializados em diferentes áreas do atendimento e suporte</p>
      </div>
      
      <div className="astro-agents-layout">
        {/* Barra lateral esquerda */}
        <div className="sidebar">
          {/* Seção de agentes */}
          <div className="sidebar-section">
            <h3>Agentes Disponíveis</h3>
            <div className="agents-list">
              {agents.map(agent => (
                <div 
                  key={agent.id}
                  className={`agent-item ${selectedAgent?.id === agent.id ? 'selected' : ''}`}
                  onClick={() => handleAgentSelect(agent)}
                >
                  <div className="agent-avatar">
                    <span>{agent.name.charAt(0)}</span>
                  </div>
                  <div className="agent-info">
                    <div className="agent-name">{agent.name}</div>
                    <div className="agent-description">{agent.description}</div>
                  </div>
                  <div className={`agent-status ${agent.status}`}></div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Seção de conversas recentes */}
          <div className="sidebar-section">
            <h3>Conversas Recentes</h3>
            <div className="conversations-list">
              {conversations.map(conversation => (
                <div 
                  key={conversation.id}
                  className={`conversation-item ${selectedConversation?.id === conversation.id ? 'selected' : ''}`}
                  onClick={() => handleConversationSelect(conversation)}
                >
                  <div className="conversation-agent-avatar">
                    <span>{conversation.agentName.charAt(0)}</span>
                  </div>
                  <div className="conversation-info">
                    <div className="conversation-title">{conversation.title}</div>
                    <div className="conversation-preview">{conversation.preview}</div>
                    <div className="conversation-timestamp">{conversation.timestamp}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/* Área principal de chat */}
        <div className="chat-area">
          {selectedAgent || selectedConversation ? (
            <>
              <div className="chat-header">
                <div className="chat-agent-info">
                  <div className="chat-agent-avatar">
                    <span>{selectedAgent ? selectedAgent.name.charAt(0) : selectedConversation.agentName.charAt(0)}</span>
                  </div>
                  <div>
                    <div className="chat-agent-name">
                      {selectedAgent ? selectedAgent.name : selectedConversation.agentName}
                    </div>
                    <div className="chat-agent-status">
                      {selectedAgent ? selectedAgent.description : `Conversa sobre "${selectedConversation.title}"`}
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="chat-messages">
                {messages.map(message => (
                  <div key={message.id} className={`message ${message.sender}`}>
                    <div className="message-content">
                      {message.content}
                    </div>
                    <div className="message-timestamp">
                      {message.timestamp}
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="chat-input-area">
                <div className="chat-input-container">
                  <textarea
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Digite sua mensagem... (Pressione Enter para enviar)"
                    rows="3"
                  />
                  <button 
                    className="send-button"
                    onClick={handleSendMessage}
                    disabled={newMessage.trim() === ''}
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="chat-placeholder">
              <div className="placeholder-content">
                <h3>Bem-vindo ao Astro Agentes</h3>
                <p>Selecione um agente de IA ou uma conversa recente para começar</p>
                <div className="placeholder-illustration">
                  <div className="galaxy-icon">🤖</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AstroAgentsPage;
